export const STOP_LOADING_PROGRAM = "STOP_LOADING_PROGRAM";
export const GET_PROGRAM_DATA = "GET_PROGRAM_DATA";
export const SET_PROGRAM_DATA = "SET_PROGRAM_DATA";
